import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    deleteItem,
    fetchPaginationData,
    handleDragEnd,
    updateStatus,
} from "../../utils/apiUtils";
import DeleteModel from "../../Components/DeleteModel";
import Spinner from "../../Components/spinner";
import Breadcrumb from "../../Components/Breadcrumb";
import Pagination from "../../Components/Pagination";
import {
    ActionButton,
    checkImage,
    PlusButton,
    ToggleSwitch,
} from "../../Components/TableHelper";
import { formatDate } from "../../utils/constant";
import TableSearch from "../../Components/TableSearch";
import PerPageSelect from "../../Components/PerPageSelect";
import { useDebounce } from "../../hooks/useDebounce";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const Services = () => {
    const [loading, setLoading] = useState(false);
    const [data, setdata] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [nextSortOrder, setNextSortOrder] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteItemId, setDeleteItemId] = useState({});
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const [perPage, setPerPage] = useState(25);
    const [search, setSearch] = useState("");
    const navigator = useNavigate();

    const fetchDataPagination = async (
        page = 1,
        currentSearch = search,
        currentPerPage = perPage,
    ) => {
        const requestData = {
            perPage: currentPerPage,
            pageNo: page,
            search: currentSearch,
        };
        await fetchPaginationData(
            "service/service-pagination",
            requestData,
            setdata,
            setTotalCount,
            setCurrentPage,
            setLoading,
            setNextSortOrder,
        );
    };
    useEffect(() => {
        fetchDataPagination(1);
    }, []);

    const debouncedFetch = useDebounce((searchValue) => {
        fetchDataPagination(1, searchValue);
    }, 500);

    const handleSearchChange = (value) => {
        setSearch(value);
        debouncedFetch(value);
    };
    const handlePerPageChange = (value) => {
        setPerPage(value);
        fetchDataPagination(1, search, value);
    };
    const totalPages = Math.ceil(totalCount / perPage);
    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
            fetchDataPagination(page);
        }
    };

    const handleDelete = async (data) => {
        setDeleteItemId(data);
        setDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        setIsDeleting(true);
        try {
            const res = await deleteItem(
                "service/deleteservice",
                deleteItemId?._id,
                fetchDataPagination,
            );
            setDeleteItemId({});
            setDeleteModalOpen(false);
            return res;
        } catch (error) {
            return error;
        } finally {
            setIsDeleting(false);
        }
    };

    const handleStatusToggle = async (item) => {
        const updated = await updateStatus(item?._id, "service", "Service");

        if (!updated) return;

        setdata((prev) =>
            prev.map((curr) =>
                curr._id === updated._id
                    ? { ...curr, isActive: updated.isActive }
                    : curr,
            ),
        );
    };
    const handleOnDragEnd = (result) => {
        handleDragEnd({
            result,
            data: data,
            label: "Services",
            setData: setdata,
            model: "services",
        });
    };

    const handleAdd = () => {
        navigator("/add-service", { state: { sortOrder: nextSortOrder } });
    };
    const handleEditClick = (item) => {
        navigator("/add-service", {
            state: item,
        });
    };

    const Tableheader = [
        "Sort Order",
        "Name",
        "Image",
        "Is Active",
        "Updated At",
        "Action",
    ];

    const breadcrumbdata = [
        { label: "Home", path: "/dashboard" },
        { label: "Services", path: "/services" },
    ];

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header">
                    <h3 className="custom-page-title">Services</h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>
                <div className="d-flex justify-content-between align-items-center bg-white p-2 mt-n2 flex-wrap gap-2">
                    <div className="d-flex align-items-center gap-2">
                        <PerPageSelect value={perPage} onChange={handlePerPageChange} />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <TableSearch
                            value={search}
                            onChange={handleSearchChange}
                            placeholder="Search By Name..."
                        />
                        <PlusButton handleAdd={handleAdd} module={"Services"} />
                    </div>
                </div>

                <div className="row" style={{ marginTop: "10px" }}>
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                    <Droppable droppableId="services">
                                        {(provided) => (
                                            <div
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                className="table-responsive"
                                            >
                                                <table
                                                    className=" custom-table table table-striped"
                                                    id="slidertable"
                                                >
                                                    <thead>
                                                        <tr>
                                                            {Tableheader.map((item, index) => (
                                                                <th className="font-weight-bold " key={index}>
                                                                    {item}
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {loading ? (
                                                            <tr>
                                                                <td colSpan="12" className="text-center">
                                                                    <Spinner />
                                                                </td>
                                                            </tr>
                                                        ) : data?.length > 0 ? (
                                                            data.map((item, index) => (
                                                                <Draggable
                                                                    key={item._id}
                                                                    draggableId={item._id.toString()}
                                                                    index={index}
                                                                >
                                                                    {(provided) => (
                                                                        <tr
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            ref={provided.innerRef}
                                                                        >
                                                                            <td>{item.sortOrder}</td>
                                                                            <td>{item.name}</td>

                                                                            <td>
                                                                                {checkImage(item.image, item.title)}
                                                                            </td>
                                                                            <td>
                                                                                <ToggleSwitch
                                                                                    data={item}
                                                                                    name="isActive"
                                                                                    checked={item.isActive}
                                                                                    handleStatusToggle={
                                                                                        handleStatusToggle
                                                                                    }
                                                                                    module={"Services"}
                                                                                />
                                                                            </td>
                                                                            <td>{formatDate(item.updatedAt)}</td>
                                                                            <td>
                                                                                <ActionButton
                                                                                    data={item}
                                                                                    handleEditClick={handleEditClick}
                                                                                    handleDelete={handleDelete}
                                                                                    module={"Services"}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </Draggable>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="12" className="text-center">
                                                                    <h5>No data found.</h5>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>

                                {data?.length > 0 && (
                                    <div>
                                        <Pagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={handlePageClick}
                                            perPage={perPage}
                                            totalCount={totalCount}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {deleteModalOpen && (
                <Suspense fallback={null}>
                    <DeleteModel
                        deleteModalOpen={deleteModalOpen}
                        setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
                        onConfirm={confirmDelete}
                        itemName="services"
                        isDeleting={isDeleting}
                    />
                </Suspense>
            )}
        </>
    );
};

export default Services;
